import { sortBy } from '@sorare/core/src/lib/arrays';

import type {
  CollectionAnimationCompetitionQuery,
  CollectionAnimationCompetition_anyCardInterface,
} from './__generated__/index.graphql.ts';

export const useDisplayedCollections = ({
  cardCollections,
  newCards,
}: {
  cardCollections: NonNullable<
    NonNullable<
      CollectionAnimationCompetitionQuery['currentUser']
    >['competitionCardCollections']
  >[number]['cardCollections'];
  newCards: CollectionAnimationCompetition_anyCardInterface[];
}) => {
  let result = sortBy(
    cardCollection => cardCollection.anyTeam?.shortName || '',
    [...cardCollections]
  );
  const firstCollectionIndexWithNewCard = result.findIndex(cardCollection =>
    cardCollection.userCardCollection.slots.some(slot =>
      newCards.some(
        card => card.slug === slot.highlightedCardCollectionCard?.anyCard.slug
      )
    )
  );
  result = result.slice(firstCollectionIndexWithNewCard);
  return result;
};
